// src/pages/context/AlertContext.js
import React, { createContext, useContext, useState, useCallback } from "react";
import { Snackbar, Alert, IconButton } from "@mui/material";
import Icon from "@mui/material/Icon";

const AlertCtx = createContext({ showAlert: () => {} });

export const AlertProvider = ({ children }) => {
  // estado único do toast
  const [s, set] = useState({
    open: false,
    severity: "info", // 'success' | 'info' | 'warning' | 'error'
    msg: "",
    duration: 3500, // ms
    persist: false, // se true, não fecha automaticamente
    actionLabel: "Dispensar",
  });

  /**
   * showAlert(message, severity?, options?)
   *  - severity: 'success' | 'info' | 'warning' | 'error' (default: 'info')
   *  - options:
   *      - duration: number (ms) -> tempo de auto-esconder (ignorado se persist=true)
   *      - persist:  boolean     -> se true, o toast não fecha sozinho
   *      - actionLabel: string   -> texto ARIA do botão de fechar (default "Dispensar")
   */
  const showAlert = useCallback((msg, severity = "info", options = {}) => {
    set({
      open: true,
      severity,
      msg,
      duration: options.duration ?? 3500,
      persist: !!options.persist,
      actionLabel: options.actionLabel ?? "Dispensar",
    });
  }, []);

  const handleClose = (_evt, _reason) => {
    set((x) => ({ ...x, open: false }));
  };

  return (
    <AlertCtx.Provider value={{ showAlert }}>
      {children}

      <Snackbar
        open={s.open}
        onClose={handleClose}
        // se persistir, não tem autoHideDuration
        autoHideDuration={s.persist ? null : s.duration}
        anchorOrigin={{ vertical: "top", horizontal: "center" }}
        action={
          <IconButton size="small" color="inherit" aria-label={s.actionLabel} onClick={handleClose}>
            <Icon fontSize="small">close</Icon>
          </IconButton>
        }
      >
        <Alert
          onClose={handleClose}
          severity={s.severity}
          variant="filled"
          sx={{ alignItems: "center" }}
        >
          {s.msg}
        </Alert>
      </Snackbar>
    </AlertCtx.Provider>
  );
};

export const useAlert = () => useContext(AlertCtx);
